import { Component } from '@angular/core';
import { BaseListDirective } from 'src/app/directives/base-list.directive';
import { PrimeNGTableColumn } from 'src/app/models/AppGenericClasses';
import { BaseFormSourceInterface } from 'src/app/services/data/global-data.service';

@Component({
  selector: 'app-wall-table',
  templateUrl: './wall-table.component.html',
  styleUrls: ['./wall-table.component.sass']
})
export class WallTableComponent extends BaseListDirective {



  form = {
    users: [],
    wall_id: null
  }
  userSelected
  override availableColumns: PrimeNGTableColumn[] = [
    new PrimeNGTableColumn('name_', 'FORM.NAME', 200, { frozen: true }),
    new PrimeNGTableColumn('description_', 'FORM.DESCRIPTION', 200, { frozen: true }),
  ];

  isReponsableWarriorVisible = false
  override title = 'MENU.WALLS';
  override filterableFields = ['name_']
  override keys = {
    primary_key: 'wall_id',
    label: 'name_'
  }
  override filename = 'MENU.WALLS';

  override getList(): void {
    this.query(this.data.core.walls()).subscribe()
    this.data.core.cities().subscribe(data => this.data.sources.city.data = data)
    this.data.core.states().subscribe(data => this.data.sources.states.data = data)

    /* this.data.load('city') */
    this.data.load('user_available')
    /* this.data.load('states') */
  }

  override handleRows(data: any): void {
    super.handleRows(data);
  }

  override refreshActionServices(): void {
    this.inactivationService = this.data.core.wallDelete(
      this.itemSelected[this.keys.primary_key]
    )
  }

  openDialogResponsables(row) {
    this.itemSelected = row
    this.form.wall_id = row.wall_id
    if (row.wall_responsable?.length > 0) {
      this.form.users = row.wall_responsable.map(wr => {
        return {
          user_id: wr.user_id,
          full_name: wr.user.first_name + ' ' + wr.user.last_name,
          cities: wr.city_ids.split(',').map(c => +c),
          sourceCities: this.data.sources.city.data,
          sourceStates: this.data.sources.states.data,
          states:[]
        }
      });


    }


    this.isReponsableWarriorVisible = true
  }

  removeUser(item) {
    let payload = {
      wall_id: this.itemSelected.wall_id,
      user_id: item.user_id
    }

    this.form.users = this.form.users.filter(u => u.user_id !== item.user_id)

    this.data.core.RemoveUserWall(payload).subscribe(data => {

      this.utils.toast.saved('CORE.REMOVE-USER')
      this.getList()
    })




  }

  onSelectUser(selected) {


    setTimeout(() => {
      this.userSelected = null;
    }, 200);

    const rs = this.form.users.filter(
      (it) => it.user_id === selected.user_id
    );
    if (rs.length) {
      return;
    }


    this.form.users.push(
      {
        ...selected,
        cities: [],
        sourceCities: this.data.sources.city.data,
        sourceStates: this.data.sources.states.data,
        states:[]
      }
    );


  }

  filterByState(item){


    if(item.states.length > 0){
      item.sourceCities = this.data.sources.city.data.filter( c=>  item.states.includes(c.state_id) ||  item.cities.includes(c.city_id) )
    }else{
      item.sourceCities = this.data.sources.city.data
    }
  }


  onSaveResponsable() {



    this.data.core.wallResposableCreate(
      {
        ...this.form,
        users: this.form.users.map(u => {
          return {
            user_id: u.user_id,
            cities: u.cities.join(',')
          }
        })
      }
    ).subscribe(data => {
      this.isReponsableWarriorVisible = false
      this.form = {

        users: [],
        wall_id: null
      }
      this.itemSelected = null

      this.utils.toast.saved(this.title)
      this.getList();
    })
  }
}
